import { useQuery } from 'react-query';
import { getOauthUserInfo } from '@general/api/oauth';

const useOauthUserInfo = () => {
    const { data, ...rest } = useQuery(
        'oauth-user-info',
        async () => {
            const userInfo = await getOauthUserInfo();
            return userInfo || null;
        },
        {
            staleTime: Infinity,
        }
    );

    return { userInfo: data, ...rest };
};

export default useOauthUserInfo;
